import React from 'react';
import PropTypes from 'prop-types';

const Hourglass = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill="#B0BAC6"
      d="M15.19 18H2.814a.563.563 0 0 1 0-1.125H15.19a.563.563 0 0 1 0 1.125M14.065 4.5V2.25H3.939V4.5c0 2.208 1.506 3.763 2.415 4.5-.909.737-2.415 2.292-2.415 4.5v2.25h1.688s1.446-3.375 3.375-3.375 3.375 3.375 3.375 3.375h1.688V13.5c0-2.208-1.506-3.763-2.415-4.5.909-.737 2.415-2.292 2.415-4.5M15.19 1.125H2.814a.563.563 0 0 1 0-1.125H15.19a.563.563 0 0 1 0 1.125"
    ></path>
  </svg>
);

Hourglass.propTypes = {
  size: PropTypes.number,
};

Hourglass.defaultProps = {
  size: 18
};

export default Hourglass;
